export const STALE_TIMES = {
  student: 5 * 60 * 1000,
  document: 2 * 60 * 1000,
  roster: 10 * 60 * 1000,
  audit: 30 * 1000,
  backup: 15 * 1000,
  export: 10 * 1000,
  calendar: 5 * 60 * 1000,
  webhook: 60 * 1000,
} as const

export const CACHE_TIMES = {
  student: 30 * 60 * 1000,
  document: 15 * 60 * 1000,
  roster: 60 * 60 * 1000,
  audit: 5 * 60 * 1000,
  backup: 2 * 60 * 1000,
  export: 60 * 1000,
  calendar: 30 * 60 * 1000,
  webhook: 5 * 60 * 1000,
} as const

export const RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: (attempt: number) => Math.min(1000 * 2 ** attempt, 10000),
  retryOn: (failureCount: number, error: Error) => {
    if (error instanceof TypeError) return false
    return failureCount < 3
  },
} as const
